var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"btn base-button",class:{
    'btn-default': _vm.variant === 'default',
    'btn-primary': _vm.variant === 'primary',
    'btn-secondary': _vm.variant === 'secondary',
    'btn-inline': _vm.inline,
    'btn-small': _vm.size === 'small',
  },attrs:{"disabled":_vm.disabled}},'component',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"btn-inner"},[_vm._t("default"),(_vm.showArrow)?_c('ArrowRight',{staticClass:"btn-icon"}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }